import React, { useContext } from 'react';
import Button from '../../components/Button';
import { SCREENS } from '../../constants';
import { GlobalContext } from '../../context/GlobalState';
import { ErrorContainer, ErrorText } from './style';
import { logEvent, TrackingEvents } from '../../tracking';

function NoPermissionErrorPage() {
  const { onChangeScreen } = useContext(GlobalContext);

  const goToDashboard = () => {
    logEvent(TrackingEvents.GO_BACK_TO_DASHBOARD, {
      stage: 'error page',
    });
    onChangeScreen(SCREENS.WORKSPACE);
  };

  return (
    <ErrorContainer>
      <div>
        <img
          src={process.env.PUBLIC_URL + '/img/blank_canvas.svg'}
          alt="error"
        />
        <ErrorText>
          The retrospective you are trying to view doesn’t exist or you don't
          have permission to access it.
        </ErrorText>
        <Button onClick={goToDashboard}>Go to dashboard</Button>
      </div>
    </ErrorContainer>
  );
}

export { NoPermissionErrorPage };
